/**
 * Update remediation documents (arbitium_remediations).
 * Blueprint: arbitium_remediations.json.
 */

import { putRingDoc } from '../core';
import type { RemediationItem } from './create_remediation';

const RING_REMEDIATIONS = 'arbitium_remediations';

/**
 * Updates an arbitium_remediation document (partial update).
 */
export async function updateRemediation(
  remediationId: string,
  payload: Partial<Record<keyof RemediationItem, unknown>>
): Promise<boolean> {
  const res = await putRingDoc(RING_REMEDIATIONS, remediationId, payload as Record<string, unknown>);
  return res.success;
}
